<div class="accordion accordion-flush">
<% for (let site of company.sites) { %>
	<div class="accordion-item">
		<h2 class="accordion-header" id="flush-headingOne">
			<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
				<%= site.name %>
			</button>
		</h2>
		<div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
			<div class="accordion-body">
				<% for (let storage of site.storages) { %>
				<h4><%= storage.name %></h4>
				<hr />
				<div class="row g-1">
					<% for (let terminal of storage.terminals) { %>
					<div class="col-auto">
						<div class="dropend">
							<button class="btn btn-light p-2" data-bs-toggle="dropdown" style="min-width:140px;" aria-expanded="false">
								<i class="fa fa-2x fa-desktop mb-2"></i><br>
								<strong><%= terminal.name %></strong><br>
								<small class="text-primary">aktív</small>
							</button>
							<ul class="dropdown-menu">
								<li><h6 class="dropdown-header"><i class="fa fa-caret-left me-2"></i>Állapot</h6></li>
								<p class="px-3 mb-2"><small>Első indítás:<br><strong><%= Anvil.moment(terminal.first_start).format('YYYY. MM. DD. HH:mm:ss') %></strong></small></p>
								<p class="px-3 mb-2"><small>Utolsó indítás:<br><strong><%= Anvil.moment(terminal.recent_start).format('YYYY. MM. DD. HH:mm:ss') %></strong></small></p>
								<p class="px-3"><small>Elindítva:<br><strong><%= terminal.startups %> alkalommal</strong></small></p>
								<li><hr class="dropdown-divider"></li>
								<li><button class="dropdown-item" onclick="Anvil.page.editTerminal('<%= terminal.machine_id %>')"><i class="fa fa-fw fa-edit me-2"></i>Info</button></li>
							</ul>
						</div>
					</div>
					<% } %>
				</div>
				<% } %>
			</div>
		</div>
	</div>
<% } %>
</div>
